export const footerLinks = [
    {link: '/terms', label: 'Terms', hint: 'Read our terms of service'},
    {link: '/privacy', label: 'Privacy', hint: 'Read our privacy policy'},
    {link: '/cookies', label: 'Cookies', hint: 'Read our cookie policy'},
    {link: 'mailto:hello@freelimbs.com', label: 'Contact', hint: 'Get in touch with us'},
];